var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreelancerDashboardIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1928_41215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.50044 12.173L3.79814 14.8051L4.84836 9.51961L0.891968 5.86087L6.24333 5.22638L8.50044 0.333008L10.7575 5.22638L16.1088 5.86087L12.1525 9.51961L13.2027 14.8051L8.50044 12.173ZM8.50044 10.645L11.3316 12.2297L10.6992 9.04747L13.0813 6.84461L9.85937 6.46257L8.50044 3.51635L7.14147 6.46257L3.91951 6.84461L6.30158 9.04747L5.66926 12.2297L8.50044 10.645Z",
    fill: "#FFCC00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1928_41215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreelancerDashboardIcon03);
export default __webpack_public_path__ + "static/media/freelancer-dashboard-icon-03.89365c0a5d2ae44a430f4b5f2a09e7c4.svg";
export { ForwardRef as ReactComponent };